export default "__VITE_ASSET__nib8dAvD__"